export default __webpack_public_path__ + "static/media/lowest-ask-all-editions.1ae699f1.svg";